import { render, staticRenderFns } from "./ApplicationDetailsTab.vue?vue&type=template&id=239eeb06&"
import script from "./ApplicationDetailsTab.vue?vue&type=script&lang=js&"
export * from "./ApplicationDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports